import {FittingSchema} from "@generated"
import {StateLabel} from "@platform/models/state-labels/state-label"

export const FittingSchemaLabels: Map<FittingSchema, StateLabel<FittingSchema>> = new Map<FittingSchema, StateLabel<FittingSchema>>([
    [FittingSchema.Colormass, {state: FittingSchema.Colormass, label: "Colormass"}],
    [FittingSchema.Clo, {state: FittingSchema.Clo, label: "CLO"}],
])
